import { TemplateSetUpdateModalComponent } from './template-set-update-modal';

export const entryComponents = [TemplateSetUpdateModalComponent];

export * from './template-set-update-modal/template-set-update-modal';
